'use client';

import { Switch } from '../../atoms/switch/switch';

export interface ToggleRowProps {
	/** Etichetta dell'impostazione. */
	label: string;
	/** Testo secondario sotto l'etichetta. */
	sub?: string;
	/** Stato corrente dell'interruttore. */
	checked: boolean;
	/** Chiamata al click (nessun parametro: il chiamante inverte lo stato). */
	onChange: () => void;
}

/** Riga etichetta + interruttore on/off, per liste di impostazioni. */
export function ToggleRow({ label, sub, checked, onChange }: ToggleRowProps) {
	return (
		<div className="flex items-center justify-between py-1.5">
			<div>
				<div className="text-[13px] text-text-primary">{label}</div>
				{sub && <div className="text-[11px] text-text-muted">{sub}</div>}
			</div>
			{/* axe: button-name — il testo `label` è visibile accanto allo Switch ma non
			    è un <label> reale collegato: senza aria-label lo switch non ha nome
			    accessibile. */}
			<Switch checked={checked} onCheckedChange={onChange} aria-label={label} />
		</div>
	);
}
